const ADOBE_EXPERIENCE_MANAGER_INBOUND = 'adobe-experience-manager-inbound' as const
const ADOBE_EXPERIENCE_MANAGER_OUTBOUND = 'adobe-experience-manager-outbound' as const
const ADOBE_INBOUND = 'adobe-inbound' as const
const ADOBE_OUTBOUND = 'adobe-outbound' as const
const AMAZON_ADS = 'amazon-ads-inbound' as const
const AWS_S3_INBOUND = 'aws-s3-inbound' as const
const AZURE_BLOB_PUSH = 'azure-blob-push' as const
const BITLY = 'bitly' as const
const BOX_PUSH = 'box-push' as const
const BOX_PUSH_GENERAL = 'box-push-general' as const
const EMAIL_OUTPUT = 'email-output' as const
const FACEBOOK_ADS = 'facebook-ads' as const
const FACEBOOK_ADS_UPDATE = 'facebook-ads-update' as const
const GOOGLE_CLOUD = 'google-cloud' as const
const GOOGLE_DCM = 'google-dcm' as const
const GOOGLE_DCM_OUTPUT = 'google-dcm-output' as const
const NOOP = 'NOOP' as const
const QR_CODE_MONKEY = 'qr-code-monkey' as const
const S3_PUSH = 's3-push' as const
const SFTP_PULL = 'sftp-pull' as const
const SFTP_PUSH = 'sftp-push' as const
const WORKFRONT_PROJECT_PULL_TASK_TRIGGER = 'workfront-project-pull-task-trigger' as const
const BRANCH = 'branch' as const
const GOOGLE_ANALYTICS = 'google-analytics' as const
const GOOGLE_ADS_INBOUND = 'google-ads-inbound' as const
const PINTEREST_INBOUND = 'pinterest-inbound' as const
const SNAPCHAT_MARKETING_INBOUND = 'snapchat-marketing-inbound' as const
const FACEBOOK_MARKETING_INBOUND = 'facebook-marketing-inbound' as const
const SNOWFLAKE_OUTBOUND = 'snowflake-push' as const

export const integrationSlugs = {
  ADOBE_EXPERIENCE_MANAGER_INBOUND,
  ADOBE_EXPERIENCE_MANAGER_OUTBOUND,
  ADOBE_INBOUND,
  ADOBE_OUTBOUND,
  AMAZON_ADS,
  AWS_S3_INBOUND,
  AZURE_BLOB_PUSH,
  BITLY,
  BOX_PUSH,
  BOX_PUSH_GENERAL,
  EMAIL_OUTPUT,
  FACEBOOK_ADS,
  FACEBOOK_ADS_UPDATE,
  GOOGLE_CLOUD,
  GOOGLE_DCM,
  GOOGLE_DCM_OUTPUT,
  NOOP,
  QR_CODE_MONKEY,
  S3_PUSH,
  SFTP_PULL,
  SFTP_PUSH,
  WORKFRONT_PROJECT_PULL_TASK_TRIGGER,
  BRANCH,
  GOOGLE_ANALYTICS,
  GOOGLE_ADS_INBOUND,
  PINTEREST_INBOUND,
  SNAPCHAT_MARKETING_INBOUND,
  FACEBOOK_MARKETING_INBOUND,
  SNOWFLAKE_OUTBOUND,
} as const
